import React, { useEffect, createElement } from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { StatsBar } from './components/StatsBar';
import { HeroTestimonials } from './components/HeroTestimonials';
import { TomosCarousel } from './components/TomosCarousel';
import { PainPoints } from './components/PainPoints';
import { ProductOverview } from './components/ProductOverview';
import { Bonuses } from './components/Bonuses';
import { WhatYouGet } from './components/WhatYouGet';
import { Pricing } from './components/Pricing';
import { Testimonials } from './components/Testimonials';
import { CostComparison } from './components/CostComparison';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    const PIXEL_ID = '1167446325501718';
    const script = document.createElement('script');
    script.innerHTML = `
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '${PIXEL_ID}');
      fbq('track', 'PageView');
    `;
    document.head.appendChild(script);
    const noscript = document.createElement('noscript');
    const img = document.createElement('img');
    img.height = 1;
    img.width = 1;
    img.style.display = 'none';
    img.src = `https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`;
    noscript.appendChild(img);
    document.head.appendChild(noscript);
    return () => {
      document.head.removeChild(script);
      document.head.removeChild(noscript);
    };
  }, []);
  return <div className="min-h-screen bg-cream text-ink font-sans selection:bg-orange/30 selection:text-white" data-id="element-0">
      <Header data-id="element-1" />
      <Hero data-id="element-2" />
      <StatsBar data-id="element-3" />
      <HeroTestimonials data-id="element-4" />
      <TomosCarousel data-id="element-5" />
      <PainPoints data-id="element-6" />
      <ProductOverview data-id="element-7" />
      <Bonuses data-id="element-8" />
      <WhatYouGet data-id="element-9" />
      <Pricing data-id="element-10" />
      <Testimonials data-id="element-11" />
      <CostComparison data-id="element-12" />
      <Guarantee data-id="element-13" />
      <FAQ data-id="element-14" />
      <div className="border-t-4 border-orange/40" data-id="element-15">
        <Pricing data-id="element-16" />
      </div>
      <Footer data-id="element-17" />
    </div>;
}